// /app/money — the demo's Accounts page: the manager's money view across every development, two sub-tabs (?sub=), each
// behind its own permission page.
//   overview    the portfolio's money at a glance (fees or budgets; GET /accounts/overview) — read-only
//   deposits    every deposit and what needs attention (deposits) — the old Deposits page
// A sub-tab shows only to someone who can read its page (visibility follows the permissions; the data follows the user's
// scope); with one sub-tab there is no tab row, and with none the page says so. /app/deposits redirects here (App.tsx).
// The Finance group (invoices, bills, banking, arrears, the chart of accounts at /app/accounts…) stays as it is.
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../stores/auth';
import { RequirePermission } from '../components/RequirePermission';
import { AccountsOverviewTab } from '../components/portfolio/AccountsOverviewTab';
import { DepositsTab } from '../components/deposits/DepositsTab';
import { Tabs } from '../components/ui';

const MONEY_SUBS = [
  { key: 'overview', label: 'Overview', pages: ['fees', 'budgets'], Tab: AccountsOverviewTab },
  { key: 'deposits', label: 'Deposits', pages: ['deposits'], Tab: DepositsTab },
] as const;
type MoneySub = (typeof MONEY_SUBS)[number]['key'];

export default function MoneyPage() {
  const { can } = useAuth();
  const [params, setParams] = useSearchParams();
  const subs = MONEY_SUBS.filter((s) => s.pages.some((p) => can(`${p}.read`)));
  const sub = subs.find((s) => s.key === params.get('sub')) ?? subs[0];
  // Switching sub-tab drops the other one's state (?filter=…).
  const go = (k: MoneySub) => setParams(k === subs[0]?.key ? {} : { sub: k });
  if (!sub) return <RequirePermission page="fees">{null}</RequirePermission>;
  const { Tab } = sub;
  return (
    <div>
      {subs.length > 1 && (
        <Tabs className="mb-2.5" items={subs.map((s) => ({ key: s.key, label: s.label }))} value={sub.key} onChange={go} />
      )}
      <Tab key={sub.key} />
    </div>
  );
}
